var exports = {
  "kL": "x2b2fbebb--2b9c75--container",
  "wx": "x2b2fbebb--2b9c75--header",
  "VN": "x2b2fbebb--2b9c75--close",
  "Qs": "x2b2fbebb--2b9c75--content",
  "hJ": "x2b2fbebb--2b9c75--counter",
};

module.exports = exports;
